import React, { useEffect, useState } from 'react'
import deleteImg from '../../components/images/delete.svg';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { Link, useNavigate } from "react-router-dom";
import { isIOS, isMobile } from 'react-device-detect';
import ScheduleInvoice from '../../views/Classes/ScheduleInvoice';
import {
    checkMembershipDiscount, createMembers, downloadclassinvoice, getMembersbyid, memberByNumber, sendMemberwaiverUrl, getWaiverSettingsbyGymid,
    getClassBookingWaiverSettings, getMembersBySchedule, getGymAddonsList
} from '../../services/memberApiServices';
import { MDBAlert, MDBBtn, MDBCheckbox, MDBCol, MDBIcon, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBRow } from 'mdb-react-ui-kit';
import { useCart } from './CartContext';
import DigitalWaiver from '../../views/DigitalWaiver';
import MemberWaiver from './MemberWaiver';
import { idToSlug } from '../../utils/slug';
import { isEmpty } from '../../validators/helper';

function Booksessions({ invoiceCheck, handleCallback, bookaClass, setbookaClass, togglebookaClass, bussinessinfo, selectedevent, setInvoiceCheck }) {
    const {
        getMemberId,
        getGymId,
        clearCart,
        handleReload,
        getMemberNumber
    } = useCart();
    // Always use bussinessinfo._id when available (correct for both logged-in and guest/shared-link flows)
    const gymId = bussinessinfo?._id?.toString() || getGymId();
    const [success, setSuccess] = useState(false)
    const navigate = useNavigate();

    const [selectedMembers, setSelectedMembers] = useState([]);
    const [waiverModal, setWaiverModal] = useState(false);
    const [memeberInfo, setMemberInfo] = useState([])

    const [members, setMembers] = useState([]);

    const [memberform, setMemberform] = useState(
        {
            check: false,
            firstName: "",
            lastName: "",
            phone: "",
            email: ""
        },

    )
    const [showWaiverModal, setShowWaiverModal] = useState(false);
    const [selectedMemberForWaiver, setSelectedMemberForWaiver] = useState(null);
    const [isWaiverMandatory, setIsWaiverMandatory] = useState(false);
    const [refresh, setRefresh] = useState(false)
    const [showMembers, setShowMembers] = useState(false);
    const [selectedAddons, setSelectedAddons] = useState({});
    const [expandedNewParticipant, setExpandedNewParticipant] = useState(null);
    const [addons, setAddons] = useState([]);

    const [filteredAddons, setFilteredAddons] = useState([]);


    useEffect(() => {
        async function fetchAddons() {
            try {
                if (!gymId) return;


                const response = await getGymAddonsList(gymId);
                if (!response || response === "false") return;

                const data = await response.json();
                setAddons(data);

            } catch (error) {
                console.error("Error while fetching addons:", error);
            }
        }

        fetchAddons();
    }, []);

    // Filter addons based on selected event's class addons
    useEffect(() => {
        if (!addons?.length || !selectedevent?.classInfo?.addons?.length) {
            setFilteredAddons([]);
            return;
        }

        const selectedAddonIds = selectedevent.classInfo.addons.map(a => a._id);
        const filtered = addons.length > 0 && addons.filter(addon =>
            selectedAddonIds.includes(addon._id)
        );

        setFilteredAddons(filtered);
    }, [addons, selectedevent]);



    const callbackhandleCallback = () => {
        setSelectedMembers([])
        handleCallback()
    }
    const callbacktogglebookaClass = () => {
        setSelectedMembers([])
        handleClosePopup()
        togglebookaClass()
    }
    // console.log(bussinessinfo, 'bussinessinfo');
    const [memberids, setMemberids] = useState([])
    const [alreadyBookedIds, setAlreadyBookedIds] = useState([])


    useEffect(() => {
        const fetchMembers = async () => {
            if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                let waiverRequired = false;
                try {
                    if (gymId) {
                        const waiverRes = await getClassBookingWaiverSettings(gymId);
                        if (waiverRes && waiverRes !== "false") {
                            const waiverData = await waiverRes.json();
                            waiverRequired = waiverData?.iswaiver === true;
                        }
                    }
                } catch (e) {
                    console.error("Error fetching waiver settings before redirect:", e);
                }
                navigate('/memberlogin', { state: { path: window.location.pathname, waiverstatus: waiverRequired } })
                return
            }
            const membersinfo = await memberByNumber(gymId, { number: getMemberNumber() }, "user")
            if (!membersinfo || membersinfo === "false" || !membersinfo.ok) {
                return;
            }
            const members = await membersinfo.json();

            // console.log(members, 'members');
            const membersArray = Array.isArray(members) ? members : [];
            setMemberInfo(membersArray)
            const ids = membersArray.length > 0 ? membersArray.map(m => ({ id: m._id?.toString() || m.id })) : [];

            setMemberids(ids);
        }

        if ((gymId)) {
            fetchMembers()
        }

    }, [getMemberNumber, gymId])

    const fetchMembersBySchedule = async () => {
        try {
            const updates = {
                gymid: gymId,
                scheduleId: selectedevent?.scheduleinfo?._id
            };
            const res = await getMembersBySchedule(selectedevent?.scheduleinfo?._id, updates);
            if (!res || res === "false") {
                return
            }
            const data = await res.json();
            console.log("Fetched Schedule Data:", data);
            const bookedIds = (data?.tableData || []).map(member => member.id).filter(Boolean);
            setAlreadyBookedIds(bookedIds);

        } catch (error) {
            console.error("Error fetching schedule data:", error);
        }
    };

    useEffect(() => {
        setAlreadyBookedIds([]);
        if (selectedevent?.scheduleinfo?._id) {
            fetchMembersBySchedule()
        }

    }, [selectedevent, gymId])
    const fetchMembersbyid = async () => {
        if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
            navigate('/memberlogin', { state: { path: '/memberdashboard' } })
        } else {
            const membersinfo = await getMembersbyid(gymId, { memberids });
            if (!membersinfo || membersinfo === "false" || !membersinfo.ok) {
                return;
            }
            const members = await membersinfo.json();
            // console.log(members, "members");
            setMemberInfo(Array.isArray(members) ? members : []);
        }

    };

    useEffect(() => {

        if (memberids && memberids.length > 0) {
            // Call once immediately
            fetchMembersbyid();

            // Set interval to call every 10 seconds
            const intervalId = setInterval(fetchMembersbyid, 20000);

            // Cleanup when component unmounts or deps change
            return () => clearInterval(intervalId);
        }

    }, [memberids]);

    const [WaiverForm, setWaiverForm] = useState({})
    async function fetchData() {
        if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
            navigate('/memberlogin', { state: { path: '/memberdashboard' } })
            return
        }
        const waiverRes = await getWaiverSettingsbyGymid(
            gymId
        );
        if (waiverRes === "false") {
            // setApiError(true)
        } else {
            const waiver = await waiverRes.json();
            // console.log(waiver);
            setWaiverForm(waiver)
        }
    }

    useEffect(() => {

        const fetchWaiverSettings = async () => {
            if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                navigate('/memberlogin', { state: { path: '/memberdashboard' } })
                return
            }
            if (gymId) {
                try {
                    const response = await getClassBookingWaiverSettings(gymId);
                    if (response && response !== "false") {
                        const result = await response.json();
                        // console.log(result, 'result');

                        setIsWaiverMandatory(result.iswaiver);
                    }
                } catch (error) {
                    console.error("Error fetching waiver settings:", error);
                }
            }
        };

        fetchWaiverSettings();
        fetchData()
    }, [gymId]);
    console.log(selectedevent, 'selectedevent');

    const handleCheckboxChange = (memberId) => {
        // For new participants, memberId will be like "new-1"
        // For existing members, memberId will be the actual MongoDB ID
        setSelectedMembers((prevSelected) => {
            const isSelected = prevSelected.includes(memberId);
            const availableSlots = (selectedevent?.slotsRemaining || 0) - (selectedevent?.slotsBooked || 0);
            const existingSelectedCount = prevSelected.filter(id => !id.startsWith('new-')).length;
            const totalParticipants = existingSelectedCount + members.length;
            const canAddMore = availableSlots > totalParticipants;

            if (!isSelected && !canAddMore) {
                alert("Slot limit has been reached");
                return prevSelected;
            }

            if (isSelected) {
                // Remove member and their addons
                const newAddons = { ...selectedAddons };
                delete newAddons[memberId];
                setSelectedAddons(newAddons);
                return prevSelected.filter((id) => id !== memberId);
            } else {
                return [...prevSelected, memberId];
            }
        });
    };

    const handleWaiver = () => {
        console.log(getMemberNumber(), '888888888888888888888');
        const update = {
            number: getMemberNumber(),
            // uniqueid: uniqueid
        }
        setWaiverModal(true)
    }

    const callbackRefreshHandler = (event) => {
        setMembers([
            { id: 1, firstName: "", lastName: "", phone: "", email: "" },
        ]);

        setWaiverModal(false)

    }



    const filteredMembers = memeberInfo && memeberInfo.length > 0 ? memeberInfo.filter(member => selectedMembers.includes(member._id)) : [];
    const [discountData, setDiscountData] = useState()
    const [sendLink, setSendLink] = useState(false)

    useEffect(() => {
        const checkMembership = async () => {
            const update = {
                memebership: selectedevent?.classInfo?.membershipdiscount,
                memebersid: selectedMembers
            }
            const membersinfo = await checkMembershipDiscount(gymId, update, "user")
            if (!membersinfo || membersinfo === "false") {
                return;
            }
            const members = await membersinfo.json();
            setDiscountData(members?.discountEligibleMembers ? members.discountEligibleMembers : [])
        }

        if (selectedevent && selectedevent?.classInfo && selectedevent?.classInfo?.membershipdiscount.length > 0) {
            if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                navigate('/memberlogin', { state: { path: '/memberdashboard' } })
            }
            checkMembership()

        }

    }, [invoiceCheck])


    const addNewRow = () => {
        const availableSlots = (selectedevent?.slotsRemaining || 0) - (selectedevent?.slotsBooked || 0);
        const existingSelectedCount = selectedMembers.filter(id => !id.startsWith('new-')).length;
        const totalParticipants = existingSelectedCount + members.length;
        if (totalParticipants >= availableSlots) {
            alert(`Only ${availableSlots} slot(s) available. Cannot add more participants.`);
            return;
        }

        // Show form if not already showing
        if (!showMembers) {
            setShowMembers(true);
        }

        // Add new row
        const newId = members.length > 0 ? Math.max(...members.map(m => m.id)) + 1 : 1;
        setMembers([
            ...members,
            {
                id: newId,
                check: true,
                firstName: "",
                lastName: "",
                phone: "",
                email: ""
            },
        ]);

        setExpandedNewParticipant(newId);

    }


    const removeRow = (id) => {
        setMembers(members.filter((member) => member.id !== id));
        // Also remove from selected if it was there
        setSelectedMembers(prev => prev.filter(mid => mid !== `new-${id}`));
        // Remove addons for this member
        const newAddons = { ...selectedAddons };
        delete newAddons[`new-${id}`];
        setSelectedAddons(newAddons);
    };

    const updateMember = (id, field, value) => {
        setMembers(
            members.map((member) =>
                member.id === id ? { ...member, [field]: value } : member
            )
        );
    };




    // Add-ons functions
    const toggleAddon = (memberId, addonId) => {
        setSelectedAddons(prev => {
            const memberAddons = prev[memberId] || [];
            const isSelected = memberAddons.includes(addonId);

            // Toggle the addon
            const newMemberAddons = isSelected
                ? memberAddons.filter(id => id !== addonId)
                : [...memberAddons, addonId];

            return {
                ...prev,
                [memberId]: newMemberAddons
            };
        });
    };


    // Calculate volume discount
    const calculateVolumeDiscount = () => {
        const selectedCount = selectedMembers.length;
        const volumeDiscounts = selectedevent?.classInfo?.volumediscount || [];

        // Sort discounts by discount percentage in descending order
        const sortedDiscounts = [...volumeDiscounts].sort((a, b) => {
            const discountA = parseFloat(a.discount || 0);
            const discountB = parseFloat(b.discount || 0);
            return discountB - discountA; // Highest discount first
        });

        // Find the best discount that the selected count qualifies for
        let applicableDiscount = null;
        for (const discount of sortedDiscounts) {
            if (selectedCount >= parseInt(discount.minParticipants || 0)) {
                applicableDiscount = discount;
                break; // Use the highest discount that qualifies
            }
        }

        return applicableDiscount;
    };
    // Calculate membership discount for each member
    const calculateMembershipDiscountAmount = () => {
        if (!discountData || !discountData.length) return 0;

        let totalMembershipDiscount = 0;
        const classPrice = parseFloat(selectedevent?.price || 0);

        selectedMembers.forEach(memberId => {
            const discountEntry = discountData.find(d => d.memberid === memberId);
            if (discountEntry) {
                const discountPercentage = parseFloat(discountEntry.discount) || 0;
                const memberDiscount = (classPrice * discountPercentage) / 100;
                totalMembershipDiscount += memberDiscount;
            }
        });

        return totalMembershipDiscount;
    };

    // Calculate addons total
    const calculateAddonsTotal = () => {
        let addonsTotal = 0;

        Object.entries(selectedAddons).forEach(([memberId, addonIds]) => {
            if (selectedMembers.includes(memberId)) {
                addonIds.forEach(addonId => {
                    const addon = filteredAddons?.find(a => (a._id || a.id) === addonId);
                    if (addon && addon.props?.length > 0) {
                        const addonPrice = parseFloat(addon.props[0].propvalue) || 0;
                        addonsTotal += addonPrice;
                    }
                });
            }
        });

        return addonsTotal;
    };

    // Calculate the final total (same as ScheduleInvoice will show)
    const calculateFinalTotal = () => {
        const participantCount = selectedMembers.length;
        const classPrice = parseFloat(selectedevent?.price || 0);
        const classTotal = participantCount * classPrice;

        // Calculate addons total
        const addonsTotal = calculateAddonsTotal();

        // Calculate volume discount
        const volumeDiscountInfo = calculateVolumeDiscount();
        let volumeDiscountAmount = 0;
        if (volumeDiscountInfo) {
            const discountPercentage = parseFloat(volumeDiscountInfo.discount) || 0;
            volumeDiscountAmount = (classTotal * discountPercentage) / 100;
        }

        // Calculate membership discount
        const membershipDiscountAmount = calculateMembershipDiscountAmount();

        // Final total = Class total + Addons - Volume discount - Membership discount
        const finalTotal = classTotal + addonsTotal - volumeDiscountAmount - membershipDiscountAmount;

        return {
            finalTotal: Math.max(0, finalTotal),
            classTotal,
            addonsTotal,
            volumeDiscountAmount,
            membershipDiscountAmount,
            volumeDiscountInfo,
            participantCount
        };
    };

    const getVolumeDiscountInfo = () => {
        const volumeDiscount = calculateVolumeDiscount();
        if (!volumeDiscount) return null;

        return {
            discount: parseFloat(volumeDiscount.discount) || 0,
            minParticipants: parseInt(volumeDiscount.minParticipants) || 0,
            applied: true
        };
    };

    // Prepare addon data for invoice
    const prepareAddonDataForInvoice = () => {
        const addonList = [];

        Object.entries(selectedAddons).forEach(([memberId, addonIds]) => {
            if (selectedMembers.includes(memberId)) {
                addonIds.forEach(addonId => {
                    const addon = filteredAddons.find(a => (a._id || a.id) === addonId);
                    if (addon) {
                        let memberName = "";
                        const existingMember = memeberInfo.find(m => m._id === memberId);

                        if (existingMember) {
                            memberName = `${existingMember.fname} ${existingMember.lname}`;
                        } else {
                            const newMemberId = memberId.replace('new-', '');
                            const newMember = members.find(m => m.id.toString() === newMemberId);
                            if (newMember) {
                                memberName = `${newMember.firstName} ${newMember.lastName}`.trim();
                            }
                        }

                        addonList.push({
                            id: addonId,
                            name: addon.name,
                            price: parseFloat(addon.props?.[0]?.propvalue) || 0,
                            memberId: memberId,
                            memberName: memberName || "Participant"
                        });
                    }
                });
            }
        });

        return addonList;
    };




    // New helper for participant display
    const getAllParticipants = () => {
        const existingSelected = Array.isArray(memeberInfo)
            ? memeberInfo.filter(m => selectedMembers.includes(m._id))
            : [];

        const newSelected = members
            .filter(m => m.check && m.firstName && m.phone)
            .filter(m => selectedMembers.includes(`new-${m.id}`));

        return [
            ...existingSelected.map(m => ({
                id: m._id,
                name: `${m.fname} ${m.lname}`,
                isExisting: true
            })),
            ...newSelected.map(m => ({
                id: `new-${m.id}`,
                name: `${m.firstName} ${m.lastName}`.trim(),
                isExisting: false
            }))
        ];
    };


    // Save new participant function
    const saveNewParticipant = (id) => {
        const participant = members.find(m => m.id === id);
        if (participant.firstName && participant.phone) {
            setExpandedNewParticipant(null);
            const newParticipantId = `new-${id}`;

            // Auto-select the participant if not already selected
            if (!selectedMembers.includes(newParticipantId)) {
                setSelectedMembers([...selectedMembers, newParticipantId]);
            }
        } else {
            alert('Please fill in First Name, Last Name, and Phone Number');
        }
    };

    function updateMemberform(value) {
        return setMemberform((prev) => {
            return { ...prev, ...value };
        });
    }

    const handleaddClose = () => {
        setWaiverModal(false)
    }

    const handleConfirm = async () => {
        console.log("Saved Members:", members);

        const hasEmptyFields = members.some(
            (m) =>
                !m.firstName?.trim() ||
                // !m.lastName?.trim() ||
                !m.phone?.toString().trim()
        );

        if (hasEmptyFields) {
            alert("Please fill in First Name, Last Name, and Phone Number for all members before proceeding.");
            return;
        }
        if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
            navigate('/memberlogin', { state: { path: '/memberdashboard' } })
        }
        const update = {
            memberInfo: members,
            bid: gymId,
        };

        const res = await createMembers(gymId, update, "user");
        const data = await res.json();

        if (data.membersdata && Array.isArray(data.membersdata)) {
            setMemberInfo(prevMembers =>
                Array.isArray(prevMembers)
                    ? [...prevMembers, ...data.membersdata]
                    : [...data.membersdata]
            );

            const ids = data.membersdata.map(m => ({ id: m._id?.toString() || m.id }));
            setMemberids(prevIds =>
                Array.isArray(prevIds) ? [...prevIds, ...ids] : [...ids]
            );
        }

        callbackRefreshHandler("save");
    };



    const downloadInvoice = async (trans) => {
        try {
            if (trans == null) return
            console.log(trans, "trans");

            const update = {
                tid: trans.tid,
                bid: trans.bid,
                type: "class"
            }
            const response = await downloadclassinvoice(update, "user")
            const data = await response.json();
            console.log(data, "data");

            if (data.url) {
                const link = document.createElement("a");
                link.href = data.url;
                link.setAttribute("download", "filename.pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Error fetching signed URL", error);
        }
    }

    const [error, setError] = useState(null)
    const [formerror, setFormerror] = useState({})
    const validate = () => {
        const errors = {};

        if (isEmpty(memberform.firstName)) {
            errors.firstName = "First name can't be blank";
        }

        if (isEmpty(memberform.lastName)) {
            errors.lastName = "Last name can't be blank";
        }

        if (isEmpty(memberform.phone)) {
            errors.phone = "Phone number can't be blank";
        } else if (!isValidPhoneNumber(memberform.phone)) {
            errors.phone = "Please enter a valid Phone number";
        }

        console.log(errors);

        return Object.keys(errors).length === 0 ? true : errors;
    };

    const handleBookclass = async () => {
        let newCreatedMemberIds = [];
        let tempToActualIdMap = {}; // Map temporary IDs to actual MongoDB IDs

        if (members.length > 0) {
            // Check if any new member has empty required fields
            const hasEmptyFields = members.some(
                (m) =>
                    !m.firstName?.trim() ||
                    !m.phone?.toString().trim()
            );

            if (hasEmptyFields) {
                alert("Please fill in First Name, Last Name, and Phone Number for all new members before proceeding.");
                return;
            }

            // Validate phone numbers for new members
            const invalidPhone = members.some(m =>
                m.phone && !isValidPhoneNumber(m.phone.toString())
            );

            if (invalidPhone) {
                alert("Please enter valid phone numbers for all new members.");
                return;
            }
        }

        const anyChecked = members.some(m => m.check === true);
        console.log("anyChecked", anyChecked);

        if (!anyChecked && selectedMembers.length === 0) {
            alert("Please select at least one member to proceed.");
            return;
        }

        if (members.length > 0) {
            const update = {
                memberInfo: members,
                bid: gymId,
            };

            try {
                const res = await createMembers(gymId, update, "user");
                const data = await res.json();
                console.log("resssssss", data);

                const createdMembers = data?.membersdata.length > 0 ? data?.membersdata.filter(member => member.check) : [];

                // Create mapping between temporary IDs and actual IDs
                members.forEach(member => {
                    if (member.check && member.firstName && member.phone) {
                        const tempId = `new-${member.id}`;
                        const actualMember = createdMembers.find(
                            created => created.fname === member.firstName &&
                                created.number === member.phone
                        );
                        if (actualMember) {
                            tempToActualIdMap[tempId] = actualMember._id;
                        }
                    }
                });

                // extract new member IDs
                newCreatedMemberIds = createdMembers.map((m) => m._id);

                // add to memberInfo list
                setMemberInfo((prev) =>
                    Array.isArray(prev) ? [...prev, ...createdMembers] : [...createdMembers]
                );

                // add to memberids list
                setMemberids((prev) => {
                    const newIds = createdMembers.map((m) => ({ id: m._id }));
                    return Array.isArray(prev) ? [...prev, ...newIds] : newIds;
                });

                // Replace temporary IDs with actual MongoDB IDs (synchronous check before proceeding)
                const finalSelected = selectedMembers.map(id => {
                    if (id.startsWith('new-') && tempToActualIdMap[id]) {
                        return tempToActualIdMap[id];
                    }
                    return id;
                }).filter(id => id);

                // Check slot availability synchronously before calling setInvoiceCheck
                const availableSlots = (selectedevent?.slotsRemaining || 0) - (selectedevent?.slotsBooked || 0);
                if (finalSelected.length > availableSlots) {
                    alert(`Only ${availableSlots} slot(s) available. Please reduce the number of participants.`);
                    return;
                }

                setSelectedMembers(finalSelected);

                // Update selectedMembers - replace temporary IDs with actual MongoDB IDs
                // setSelectedMembers((prevSelected) => {
                //     const updated = [...prevSelected];

                //     // Replace temporary IDs with actual IDs
                //     const finalSelected = updated.map(id => {
                //         if (id.startsWith('new-') && tempToActualIdMap[id]) {
                //             return tempToActualIdMap[id];
                //         }
                //         return id;
                //     }).filter(id => id); // Remove any undefined/null values

                //     // Check if we can add all selected members (slot limit check)
                //     const canAddMore =
                //         selectedevent?.slotsRemaining - selectedevent?.slotsBooked >= finalSelected.length;

                //     if (!canAddMore) {
                //         alert("Slot limit has been reached");
                //         return prevSelected;
                //     }

                //     return finalSelected;
                // });

                // Also update selectedAddons to use actual member IDs
                const updatedAddons = {};
                Object.entries(selectedAddons).forEach(([tempId, addonsList]) => {
                    if (tempId.startsWith('new-') && tempToActualIdMap[tempId]) {
                        updatedAddons[tempToActualIdMap[tempId]] = addonsList;
                    } else if (!tempId.startsWith('new-')) {
                        updatedAddons[tempId] = addonsList;
                    }
                });
                setSelectedAddons(updatedAddons);

                // proceed to invoice step
                if (newCreatedMemberIds.length > 0 || selectedMembers.length > 0) {
                    const selectedMemberDetails = (Array.isArray(memeberInfo) ? memeberInfo : []).filter((member) =>
                    (selectedMembers.includes(member._id) ||
                        newCreatedMemberIds.includes(member._id))
                    );

                    const membersWithoutWaiver = selectedMemberDetails.filter(
                        (member) => !member.iswaiververified
                    );

                    setInvoiceCheck((prev) => !prev);
                    setError(null);
                }

                setbookaClass(false);

            } catch (error) {
                console.error("Error booking class:", error);
            }
        }

        // If no new members, but existing members are selected
        else {
            if (selectedMembers.length > 0) {
                const selectedMemberDetails = (Array.isArray(memeberInfo) ? memeberInfo : []).filter((member) =>
                    selectedMembers.includes(member._id)
                );

                const membersWithoutWaiver = selectedMemberDetails.filter(
                    (member) => !member.iswaiververified
                );

                setInvoiceCheck((prev) => !prev);
                setError(null);
                setbookaClass(false);
            }
        }
    };



    function encryptId(id) {
        return btoa(id);
    }
    const [linkstatus, setLinkstatus] = useState("")

    const handleWaiverlink = async (memberinfo) => {
        const memberid = memberinfo._id
        const slug = idToSlug(memberid);
        console.log(slug, 'slug');
        let uniqueId = WaiverForm.uniqueNumber;
        const encryptedId = encryptId(uniqueId);
        const link = `${window.location.origin}/waiver?id=${encryptedId}&mId=${slug}`
        console.log(link, 'link');
        const update = {
            link: link,
            id: memberid,
            gymid: gymId,
            centername: bussinessinfo?.businessName
        }
        const response = await sendMemberwaiverUrl(update)
        const data = await response.json();
        console.log(data, "data");
        if (data.success) {
            setLinkstatus('success')
        } else {
            setLinkstatus("danger")
        }
        setSendLink(true)
    }
    console.log(formerror, 'formerror');
    console.log(selectedevent, 'selectedevent');
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };
    const handleClosePopup = () => {
        setbookaClass(false)
        setMemberform({
            check: true,
            firstName: "",
            lastName: "",
            phone: "",
            email: ""
        })
    }
    return (
        <div>
            <MDBModal tabIndex='-1' open={bookaClass} onClose={() => setbookaClass(false)}>
                <MDBModalDialog centered size="md">
                    <MDBModalContent style={{ maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
                        {/* Header */}
                        <MDBModalHeader>
                            <MDBModalTitle style={{ lineHeight: '21px' }}>
                                <div> <label>Book <span className='text-primary'>{selectedevent?.classInfo?.name || "UnKnown Class"}</span></label></div>
                                <label className='text-secondary h6 m-0 fw-normal'>{formatDate(selectedevent?.scheduleinfo?.startdate)} - {selectedevent?.startTime}</label>
                            </MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={callbacktogglebookaClass}></MDBBtn>
                        </MDBModalHeader>



                        {/* Body */}
                        <MDBModalBody style={{ overflowY: 'auto', flex: 1 }}>

                            <div className="mb-4">
                                <div
                                    className="d-flex align-items-start gap-2 p-3 rounded"
                                    style={{
                                        backgroundColor: "#F0F7FF",
                                        border: "1px solid #CFE3FF",
                                    }}
                                >
                                    <i
                                        className="fas fa-info-circle"
                                        style={{ color: "#4584e9ff", marginTop: "2px" }}
                                    ></i>
                                    <p className="mb-0 text-muted">
                                        <span className="fw-bold">Select participants for this booking.</span>{" "}
                                        Choose from existing members below or add new participants to book on their behalf.
                                    </p>

                                </div>
                            </div>


                            {/* Existing Members Section */}
                            <div className="exist-panel mb-4">
                                <div className="d-flex align-items-center justify-content-between w-100 mb-3">
                                    <div><strong className='text-dark'>Existing Members</strong></div>

                                </div>
                                {Array.isArray(memeberInfo) && memeberInfo.filter(m => !alreadyBookedIds.includes(m._id || m.id)).length > 0 ? (
                                    memeberInfo
                                        .filter(member => !alreadyBookedIds.includes(member._id || member.id))
                                        .map((member, index) => (
                                        <MDBCheckbox
                                            key={member._id}
                                            id={`member-${member._id}-${index}`}
                                            label={
                                                <div>
                                                    <div className="d-flex align-items-center justify-content-between w-100">
                                                        <div> {`${member.fname} ${member.lname}, ${member.number}`}</div>
                                                    </div>
                                                </div>
                                            }
                                            value={member._id}
                                            checked={selectedMembers.includes(member._id)}
                                            onChange={(e) => handleCheckboxChange(e.target.value)}
                                            style={{ width: '100%' }}
                                        />
                                    ))
                                ) : (
                                    <p>No matching member found. Please add the member through the <strong>Waiver</strong> form.</p>
                                )}
                            </div>

                            <div className="mb-4">
                                <strong className='text-dark mb-2 d-block'>New Participants</strong>

                                {/* Existing new participants */}
                                {members.map((member, index) => (
                                    <div key={member.id} className="border rounded p-3 pt-2 mb-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="d-flex align-items-center gap-2">
                                                {/* <MDBCheckbox
                                                    id={`new-member-checkbox-${member.id}`}
                                                    checked={selectedMembers.includes(`new-${member.id}`)}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            // Check if fields are filled
                                                            if (member.firstName && member.phone) {
                                                                const newParticipantId = `new-${member.id}`;
                                                                if (!selectedMembers.includes(newParticipantId)) {
                                                                    // Check slot availability
                                                                    const canAddMore = selectedevent?.slotsRemaining - selectedevent?.slotsBooked > selectedMembers.length;
                                                                    if (canAddMore) {
                                                                        setSelectedMembers([...selectedMembers, newParticipantId]);
                                                                    } else {
                                                                        alert("Slot limit has been reached");
                                                                        e.target.checked = false;
                                                                    }
                                                                }
                                                            } else {
                                                                alert('Please fill in First Name and Phone Number');
                                                                e.target.checked = false;
                                                            }
                                                        } else {
                                                            // Deselect
                                                            handleCheckboxChange(`new-${member.id}`);
                                                        }
                                                    }}
                                                /> */}
                                                {/* <span className="fw-bold">
                                                    {member.firstName}
                                                    {!member.firstName && <span className="badge bg-warning text-dark ms-2">Incomplete</span>}
                                                </span> */}
                                                <label className="text-muted">Participant details</label>
                                            </div>
                                            <MDBIcon
                                                fas
                                                icon="times"
                                                style={{ cursor: 'pointer', color: '#939393ff' }}
                                                onClick={() => removeRow(member.id)}
                                            />
                                        </div>

                                        {/* Always show form for new participants */}
                                        <MDBRow>
                                            <MDBCol md={6} className="mb-0">
                                                <label className="fw-normal mb-2 text-dark">Full Name</label>
                                                <input
                                                    className="form-control bg-light"
                                                    type="text"
                                                    placeholder="Enter full name"
                                                    value={member.firstName}
                                                    onChange={(e) => {
                                                        const fullName = e.target.value;
                                                        updateMember(member.id, "firstName", fullName);
                                                        const newParticipantId = `new-${member.id}`;
                                                        const isPhoneValid = member.phone && isValidPhoneNumber(member.phone);
                                                        if (fullName.trim() && isPhoneValid) {
                                                            if (!selectedMembers.includes(newParticipantId)) {
                                                                const canAddMore = selectedevent?.slotsRemaining - selectedevent?.slotsBooked > selectedMembers.length;
                                                                if (canAddMore) {
                                                                    setSelectedMembers(prev => [...prev, newParticipantId]);
                                                                }
                                                            }
                                                        } else {
                                                            if (selectedMembers.includes(newParticipantId)) {
                                                                setSelectedMembers(prev => prev.filter(id => id !== newParticipantId));
                                                            }
                                                        }
                                                    }}
                                                />
                                            </MDBCol>

                                            <MDBCol md={6} className="mb-0">
                                                <label className="fw-normal mb-2 text-dark">Phone Number</label>
                                                <PhoneInput
                                                    className={`form-control bg-light${member.phone && !isValidPhoneNumber(member.phone) ? ' border-danger' : ''}`}
                                                    defaultCountry="IN"
                                                    placeholder="Enter phone number"
                                                    value={member.phone}
                                                    onChange={(value) => {
                                                        updateMember(member.id, "phone", value);
                                                        const newParticipantId = `new-${member.id}`;
                                                        const isPhoneValid = value && isValidPhoneNumber(value);
                                                        if (member.firstName && isPhoneValid) {
                                                            if (!selectedMembers.includes(newParticipantId)) {
                                                                const canAddMore = selectedevent?.slotsRemaining - selectedevent?.slotsBooked > selectedMembers.length;
                                                                if (canAddMore) {
                                                                    setSelectedMembers(prev => [...prev, newParticipantId]);
                                                                }
                                                            }
                                                        } else {
                                                            if (selectedMembers.includes(newParticipantId)) {
                                                                setSelectedMembers(prev => prev.filter(id => id !== newParticipantId));
                                                            }
                                                        }
                                                    }}
                                                />
                                                {member.phone && !isValidPhoneNumber(member.phone) && (
                                                    <p className="text-danger">Enter a valid 10-digit phone number</p>
                                                )}
                                            </MDBCol>
                                        </MDBRow>
                                    </div>
                                ))}

                                {/* Add new participant button */}
                                <button
                                    onClick={addNewRow}
                                    className="w-100 border-2 rounded p-2 d-flex align-items-center justify-content-center gap-2"
                                    style={{
                                        borderStyle: 'dashed',
                                        borderColor: '#cbcbcb',
                                        backgroundColor: 'transparent',
                                        color: '#198754',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <MDBIcon fas icon="plus" />
                                    <span className="fw-bold">Add a New Participant</span>
                                </button>

                                {/* <div className="mt-3 p-2 rounded text-sm" style={{ backgroundColor: '#e9ecef' }}>
                                    Total participants: {selectedMembers.length}
                                </div> */}
                            </div>



                            {/* Add-ons Section */}
                            {selectedMembers.length > 0 && filteredAddons.length > 0 && (
                                <div className="mb-4">
                                    <strong className='text-dark mb-2 d-block'>Add-ons</strong>

                                    {getAllParticipants().map(participant => (
                                        <div key={participant.id} className="border rounded p-3 mb-3">
                                            <div className="mb-3">
                                                <h5 className="fw-normal text-dark mb-0">{participant.name}</h5>
                                                <p className="text-muted">Select add-ons for this participant</p>
                                            </div>

                                            <MDBRow className='px-2'>
                                                {filteredAddons.length > 0 && filteredAddons.map(addon => {
                                                    const isSelected = selectedAddons[participant.id]?.includes(addon._id || addon.id);
                                                    const price = addon.props?.[0]?.propvalue || 0;
                                                    return (
                                                        <MDBCol md={6} key={addon._id || addon.id} className="mb-2 px-1">
                                                            <div
                                                                onClick={() => toggleAddon(participant.id, addon._id || addon.id)}
                                                                className={`border rounded p-2 text-start ${isSelected ? 'border-primary bg-primary bg-opacity-10' : ''}`}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    transition: 'all 0.2s',
                                                                    borderWidth: isSelected ? '2px' : '1px'
                                                                }}
                                                            >
                                                                <div className="fw-bold">{addon.name}</div>
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <h6 className="text-muted mb-0">     Price: ₹{Number(price)}</h6>
                                                                    {isSelected && <MDBIcon fas icon="check" className="text-primary" />}
                                                                </div>
                                                            </div>
                                                        </MDBCol>
                                                    );
                                                })}
                                            </MDBRow>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </MDBModalBody>
                        <div className="border-top p-2 mx-4 rounded mb-3" style={{
                            background: '#f0fdf4', border: '1px solid #b9f8cf'
                        }}>
                            <div className="d-flex justify-content-between align-items-center">
                                <span>
                                    Quantity: <strong>{selectedMembers.length}</strong> participant(s)
                                </span>
                                <span className=" mb-0">
                                    Total: <label className='h4 fw-bold text-success'>₹{calculateFinalTotal().finalTotal.toLocaleString('en-IN')}
                                    </label>
                                </span>
                            </div>
                        </div>

                        <div className="text-end mx-4 mb-3">
                            <MDBBtn color='secondary' className="flex-fill me-2" onClick={callbacktogglebookaClass}>
                                Cancel
                            </MDBBtn>
                            <MDBBtn
                                className="flex-fill"
                                onClick={handleBookclass}
                                disabled={selectedMembers.length === 0}
                            >
                                Confirm
                            </MDBBtn>
                        </div>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            {/* 
            <MDBModal tabIndex='-1' open={waiverModal} onClose={() => callbackRefreshHandler("close")}>
                <MDBModalDialog size="lg">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Add Member</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={() => callbackRefreshHandler("close")}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>

                            <div className="d-flex align-items-center justify-content-end mb-4">
                                <MDBIcon
                                    fas
                                    icon="add"
                                    style={{ cursor: "pointer" }}
                                    onClick={addNewRow}
                                    className="ripple ripple-surface ripple-surface-light btn btn-primary fs-5"
                                />
                            </div>

                            <MDBRow className="">
                                {members.map((member, index) => (
                                    <>
                                        <MDBCol md={1} className="mb-3">
                                            <div className="d-flex flex-column">
                                                {index == 0 && <label className="fw-bold mb-2">
                                                    S.No
                                                </label>}
                                                <label>{member.id}.</label>
                                            </div>
                                        </MDBCol>

                                        <MDBCol md={2} className="mb-3">
                                            <div className="d-flex flex-column">
                                                {index == 0 && <label className="fw-bold mb-2">
                                                    First Name
                                                </label>}
                                                <input
                                                    className="payment_methods_input w-100"
                                                    type="text"
                                                    value={member.firstName}
                                                    onChange={(e) => updateMember(member.id, "firstName", e.target.value)}
                                                />
                                            </div>
                                        </MDBCol>


                                        <MDBCol md={2} className="mb-3">
                                            <div className="d-flex flex-column">
                                                {index == 0 && <label className="fw-bold mb-2">
                                                    Last Name
                                                </label>}
                                                <input
                                                    className="payment_methods_input w-100"
                                                    type="text"
                                                    value={member.lastName}
                                                    onChange={(e) => updateMember(member.id, "lastName", e.target.value)}
                                                />
                                            </div>
                                        </MDBCol>



                                        <MDBCol md={3} className="mb-3">
                                            <div className="d-flex flex-column">
                                                {index == 0 && <label className="fw-bold mb-2">
                                                    Phone Number
                                                </label>}
                                                <PhoneInput
                                                    className="payment_methods_input w-100"
                                                    defaultCountry="IN"
                                                    placeholder="Mobile Number"
                                                    value={member.phone}
                                                    onChange={(value) => updateMember(member.id, "phone", value)}
                                                />
                                            </div>
                                        </MDBCol>




                                        <MDBCol md={3} className="mb-3">
                                            <div className="d-flex flex-column">
                                                {index == 0 && <label className="fw-bold mb-2">
                                                    Email
                                                </label>}
                                                <input
                                                    className="payment_methods_input w-100"
                                                    type="email"
                                                    value={member.email}
                                                    onChange={(e) => updateMember(member.id, "email", e.target.value)}
                                                />
                                            </div>
                                        </MDBCol>



                                        <MDBCol md={1} className="mb-3">
                                            <div className="d-flex flex-column">
                                                {index == 0 && <label className="fw-bold mb-2">
                                                    Action
                                                </label>}
                                                <div className="" onClick={() => removeRow(member.id)}>
                                                    <img src={deleteImg} width="15px" alt="Delete" />
                                                </div>
                                            </div>
                                        </MDBCol>


                                    </>
                                ))}
                            </MDBRow>

                            <div className="payments d-none">
                                <ul className="mb0">
                                    <div className="d-flex align-items-center mb-2">
                                        <label className="fw-bold w-5 payment_methods_input border-0 ms-5">
                                            S.No
                                        </label>
                                        <label className="fw-bold w-20 payment_methods_input border-0 ms-5">
                                            First Name
                                        </label>
                                        <label className="fw-bold w-20 payment_methods_input border-0">
                                            Last Name
                                        </label>
                                        <label className="fw-bold w-20 payment_methods_input border-0">
                                            Phone Number
                                        </label>
                                        <label className="fw-bold w-20 payment_methods_input border-0">
                                            Email
                                        </label>
                                        <label className="fw-bold w-20 payment_methods_input border-0">
                                            Action
                                        </label>
                                    </div>

                                    {members.map((member) => (
                                        <li key={member.id} className="Business__Details__data">
                                            <div className="d-flex align-items-center ms-4">
                                                <span className="ms-4">  <label >{member.id}.</label>   </span>
                                                <span className="ms-4">
                                                    <input
                                                        className="payment_methods_input me-2"
                                                        type="text"
                                                        value={member.firstName}
                                                        onChange={(e) => updateMember(member.id, "firstName", e.target.value)}
                                                    />
                                                </span>
                                                <span>
                                                    <input
                                                        className="payment_methods_input me-2"
                                                        type="text"
                                                        value={member.lastName}
                                                        onChange={(e) => updateMember(member.id, "lastName", e.target.value)}
                                                    />
                                                </span>
                                                <span className="d-flex">
                                                    <PhoneInput
                                                        className="payment_methods_input"
                                                        defaultCountry="IN"
                                                        placeholder="Mobile Number"
                                                        value={member.phone}
                                                        onChange={(value) => updateMember(member.id, "phone", value)}
                                                    />
                                                </span>
                                                <span className="d-flex ms-3">
                                                    <input
                                                        className="payment_methods_input"
                                                        type="email"
                                                        value={member.email}
                                                        onChange={(e) => updateMember(member.id, "email", e.target.value)}
                                                    />
                                                </span>
                                                <span>
                                                    <button type="button" className="ml20 button-link" onClick={() => removeRow(member.id)}>
                                                        <img src={deleteImg} width="15px" alt="Delete" />
                                                    </button>
                                                </span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </MDBModalBody>

                        <MDBModalFooter className="pe-2 pb-2">
                            <MDBBtn color="secondary" onClick={handleaddClose}>Cancel</MDBBtn>
                            <MDBBtn onClick={handleConfirm}>Add Member(s)</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>


            </MDBModal> */}
            {
                invoiceCheck && (<div>
                    <ScheduleInvoice scheduleinfo={selectedevent} selectedMembers={selectedMembers} memeberInfo={filteredMembers} bussinessinfo={bussinessinfo} discountMembers={discountData} callbackUrl={callbackhandleCallback} downloadInvoice={downloadInvoice} uniqueNumber={WaiverForm.uniqueNumber} filteredAddons={filteredAddons} selectedAddons={prepareAddonDataForInvoice()}
                        volumeDiscount={getVolumeDiscountInfo()}

                    />
                </div>)
            }

            <MDBModal
                open={showWaiverModal}
                onClose={() => setShowWaiverModal(false)}
                staticBackdrop
                tabIndex='-1'
            >
                <MDBModalDialog size="fullscreen">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>
                                Digital Waiver - {selectedMemberForWaiver?.fname} {selectedMemberForWaiver?.lname}
                            </MDBModalTitle>
                            <MDBBtn
                                className='btn-close'
                                color='none'
                                onClick={() => {
                                    setShowWaiverModal(false);
                                    setSelectedMemberForWaiver(null);
                                }}
                            ></MDBBtn>
                        </MDBModalHeader>

                        <MDBModalBody>
                            {selectedMemberForWaiver && (
                                <MemberWaiver
                                    logourl={bussinessinfo?.logourl}
                                    member={selectedMemberForWaiver}
                                    gymid={gymId}
                                    onComplete={callbackRefreshHandler}
                                    onWaiverSubmitted={(updatedMember) => {
                                        setShowWaiverModal(false);
                                        // setRefresh(prev => !prev);
                                        fetchMembersbyid()
                                    }}
                                    onCancel={() => {
                                        setShowWaiverModal(false);
                                        setSelectedMemberForWaiver(null);
                                    }}
                                />
                            )}
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            <MDBAlert
                color={linkstatus}
                autohide
                position='top-right'
                delay={2000}
                appendToBody
                open={sendLink}
                onClose={() => setSendLink(false)}
            >{linkstatus == 'success' ? "Waiver send Successfully!" : "Waiver not send Successfully!"}
            </MDBAlert>
            {
                error !== null && <MDBAlert
                    color={'danger'}
                    autohide
                    position='top-center'
                    delay={5000}
                    appendToBody
                    open={error != null ? true : false}
                    onClose={() => setError(null)}
                >
                    {error}
                </MDBAlert>
            }
        </div>
    )
}

export default Booksessions
